<template>
  <div class="mall-box">
    <div class="back-box" @click="$router.push({ path: '/mall' })">
      <img
        src="@/assets/img/images/icon/back-border.png"
        alt="back-border.png"
      />
      <p>{{ $t("mall.detail.title") }}</p>
    </div>
    <div class="info-box">
      <div class="info-left-box">
        <div class="left-img-box">
          <div class="img-box">
            <img :src="detailData.image" alt="mall-item.png" />
            <div class="title">
              <p class="p1">{{ detailData.title }}</p>
              <!-- <p class="p2" v-if="detailData.status === 1">{{$t("mall.status1")}}</p>
              <p class="p2" v-else-if="detailData.status === 2">{{$t("mall.status2")}}</p>
              <p class="p2" v-else-if="detailData.status === 3">{{$t("mall.status3")}}</p>
              <p class="p2" v-else-if="detailData.status === 4">{{$t("mall.status4")}}</p> -->
            </div>
          </div>
          <div class="btn-box">
            <div
              class="btn1"
              v-if="
                detailData.cateCode === 'DIMD' || detailData.cateCode === 'GCT'
              "
              @click="$refs.toMallWebRef.dialogVisible = true"
            >
              {{ $t("mall.mallUrl") }}
            </div>
            <div class="btn2" @click="seePdf(detailData.cateCode)">
              {{ $t("mall.detail.showWhitePage") }}
            </div>
          </div>
        </div>
        <div class="info-bottom-box">
          <div class="info-title-box">
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.totalValue") }}</p>
              <p class="p2">{{ detailData.summary.valueInfo.totalValue }}</p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.firstValue") }}</p>
              <p class="p2">{{ detailData.summary.valueInfo.firstValue }}</p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.minBuyAmount") }}</p>
              <p class="p2">{{ detailData.summary.valueInfo.minBuyAomout }}</p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.maxBuyAmount") }}</p>
              <p class="p2">{{ detailData.summary.valueInfo.maxBuyAomout }}</p>
            </div>
          </div>
          <div class="border" />
          <div class="info-title-box">
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.goodsType") }}</p>
              <p class="p2">
                {{ detailData.summary.type }}
              </p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.mallExchange") }}</p>
              <p class="p2">
                {{ detailData.summary.serviceInfo.isMallExchange }}
              </p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.debutStartTime") }}</p>
              <p class="p2">
                {{ detailData.summary.serviceInfo.debutStartTime }}
              </p>
            </div>
            <div class="info-title">
              <p class="p1">{{ $t("mall.detail.debutEndTime") }}</p>
              <p class="p2">
                {{ detailData.summary.serviceInfo.debutEndTime }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="info-right-box">
        <p class="title">{{ $t("mall.detail.chainInfo") }}</p>
        <div class="info-title-box">
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.goodsName") }}</p>
            <p class="p2">{{ detailData.cateName }}</p>
          </div>
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.symbol") }}</p>
            <p class="p2">{{ detailData.summary.chainInfo.symbol }}</p>
          </div>
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.network") }}</p>
            <p class="p2">{{ detailData.summary.chainInfo.network }}</p>
          </div>
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.protocol") }}</p>
            <p class="p2">{{ detailData.summary.chainInfo.protocol }}</p>
          </div>
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.publishAmount") }}</p>
            <p class="p2">{{ detailData.summary.valueInfo.totalValue }}</p>
          </div>
          <div class="info-title">
            <p class="p1">{{ $t("mall.detail.contract") }}</p>
            <div class="p3">
              {{
                isShow
                  ? detailData.summary.chainInfo.contract
                  : truncateString(detailData.summary.chainInfo.contract)
              }}
              <div class="btn" v-if="!isShow" @click="isShow = true">
                {{ $t("mall.detail.view") }}
              </div>
              <div class="btn" v-if="isShow" @click="isShow = false">
                {{ $t("mall.detail.hide") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-box">
      <div class="tab">
        <div class="sel">{{ $t("mall.detail.tab1") }}</div>
      </div>
      <div class="detail-box">
        <div class="rich-content" v-html="detailData.content">
          {{ detailData.infotext }}
        </div>
      </div>
    </div>

    <VFooter />
    <ToMallWeb ref="toMallWebRef" @confirm="toMallWebConfirm" />
    <QuestionPopup />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ToMallWeb from "./components//ToMallWeb";
import VFooter from "@/components/footer/VFooter";
import QuestionPopup from "@/components/QuestionPopup/index";
export default {
  components: {
    VFooter,
    ToMallWeb,
    QuestionPopup,
  },
  data() {
    return {
      isShow: false,
      detailData: {},
    };
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  created() {
    if (!this.$route.query.cateCode) return;
    this.$axios
      .post("/cms/getDetail", {
        cateCode: this.$route.query.cateCode,
      })
      .then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.detailData = res.data.data || {};
          this.detailData.summary = JSON.parse(this.detailData.summary);
        }
      });
  },
  methods: {
    truncateString(str) {
      if (!str) return "";
      if (str.length <= 10) return str; // 如果字符串本身就不长，直接返回

      const start = str.slice(0, 6);
      const end = str.slice(-4);
      return `${start}...${end}`;
    },
    getImageUrl(imagePath) {
      if (imagePath) return require(`@/assets/img/images/${imagePath}`);
    },
    toMallWebConfirm() {
      this.$refs.toMallWebRef.dialogVisible = true;
      window.open(this.detailData.summary.serviceInfo.mallUrl);
    },
    seePdf(val) {
      window.open("PDF/" + val + ".pdf");
    },
  },
};
</script>

<style lang="less" scoped>
.mall-box {
  position: relative;
  background: #f5f6f7;
  .back-box {
    gap: 28px;
    display: flex;
    cursor: pointer;
    align-items: center;
    padding: 120px 260px 60px 260px;
    img {
      width: 44px;
      height: 44px;
    }
    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 36px;
      color: #333333;
    }
  }
  .info-box {
    gap: 32px;
    display: flex;
    padding: 0 260px;
    .info-left-box {
      padding: 20px;
      flex: 1;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      .left-img-box {
        display: flex;
        padding-bottom: 20px;
        justify-content: space-between;
        border-bottom: 1px solid #e2e3e3;
        .img-box {
          gap: 20px;
          display: flex;
          img {
            width: 120px;
            height: 120px;
          }
          .title {
            gap: 20px;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            flex-direction: column;
            .p1 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 800;
              font-size: 24px;
              color: #333333;
            }
            .p2 {
              width: 72px;
              height: 28px;
              line-height: 28px;
              text-align: center;
              background: #eaebed;
              border-radius: 4px 4px 4px 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #333333;
            }
          }
        }
        .btn-box {
          gap: 12px;
          display: flex;
          align-items: center;
          .btn1 {
            width: 152px;
            height: 52px;
            cursor: pointer;
            line-height: 52px;
            text-align: center;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #4063ff;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #4063ff;
          }
          .btn2 {
            width: 152px;
            height: 52px;
            cursor: pointer;
            line-height: 52px;
            text-align: center;
            background: #4063ff;
            border-radius: 8px 8px 8px 8px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;
          }
        }
      }
      .info-bottom-box {
        display: flex;
        margin-top: 20px;
        .border {
          margin: 0 20px;
          border-right: 1px solid #e2e3e3;
        }
        .info-title-box {
          flex: 1;
          gap: 12px;
          display: flex;
          flex-direction: column;
          .info-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .p1 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #999999;
            }
            .p2 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 800;
              font-size: 16px;
              color: #333333;
            }
          }
        }
      }
    }
    .info-right-box {
      padding: 20px;
      width: 568px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #e2e3e3;
      }
      .info-title-box {
        flex: 1;
        gap: 12px;
        display: flex;
        flex-direction: column;
        .info-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .p1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #999999;
          }
          .p2 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 800;
            font-size: 16px;
            color: #333333;
          }
          .p3 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 800;
            font-size: 16px;
            color: #333333;
            display: flex;
            gap: 4px;
          }
          .btn {
            width: 44px;
            line-height: 28px;
            text-align: center;
            height: 28px;
            background: #4b6dfe;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #4b6dfe;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
          }
        }
      }
    }
  }
  .tab-box {
    overflow: hidden;
    background: #ffffff;
    margin: 28px 260px 120px 260px;
    border-radius: 12px 12px 12px 12px;
    .tab {
      display: flex;
      border-bottom: 1px solid #e2e3e3;
      div {
        padding: 20px;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .sel {
        font-weight: 800;
        color: #4063ff;
        position: relative;
      }
      .sel::before {
        content: "";
        position: absolute;
        display: block;
        left: 0;
        width: 100%;
        bottom: 0;
        border-bottom: 2px solid #4063ff;
      }
    }
    .detail-box {
      padding: 20px;
      .rich-content {
        /deep/ img {
          width: 100%;
        }
      }
      img {
        object-fit: cover;
        width: 100%;
      }
      .file-box {
        height: 52px;
        padding: 0 20px;
        background: #f4f5f6;
        border-radius: 8px 8px 8px 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          gap: 32px;
          display: flex;
          img {
            width: 28px;
            height: 32px;
          }
          p {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 18px;
            color: #333333;
          }
        }
        .btn-box {
          gap: 20px;
          display: flex;
          .btn1 {
            width: 64px;
            height: 32px;
            cursor: pointer;
            line-height: 32px;
            text-align: center;
            background: #4b6dfe;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #4b6dfe;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
          }
          .btn2 {
            width: 64px;
            height: 32px;
            cursor: pointer;
            line-height: 32px;
            text-align: center;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #4b6dfe;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #4b6dfe;
          }
        }
      }
    }
  }
}
</style>
